const fr = {
    characters: 'caractère(s)',
    tooManyCharacters: 'caractère(s) en trop',
    toBeDetermine: 'À venir',
    isRequired: 'Ce champs est requis!',
    environmentDev: 'Environnement développement',
    environmentTest: 'Environnement de test',
    nonApplicable: 'Non applicable',
    pageTop: 'Retour en haut de la page',
    sendManager: 'Sauvegarder & notifier à mon·ma gestionnaire',
    sendManagerNoSave: 'Notifier mon·ma gestionnaire',
    managerSent: 'Votre gestionnaire a été notifié',
    doNotNotified: "Vous n'avez pas de changement à notifier",
    confidential: 'Confidentiel',
    appName: 'Portail BBA',
    applications: 'Applications',
    externalApp: 'App externe',
    back: 'Retour',
    loading: 'Chargement...',
    noOptions: 'Aucune option',
    date: 'Date',
    title: 'Titre',
    client: 'Client',
    phoneNumber: 'Numéro de téléphone',
    phone: 'Téléphone',
    typeAnswer: 'Entrez votre réponse ici',
    managerAnswer: 'Commentaires du gestionnaire',
    employeeAnswer: "Commentaires de l'employé·e",
    optional: 'facultatif',
    manage: 'Gestion',
    viewHistory: "Voir l'historique",
    viewDetails: 'Voir les détails',
    saveChanges: 'Sauvegarder les changements',
    save: 'Sauvegarder',
    saveAndClose: 'Sauvegarder et fermer',
    createAsADraft: 'Créer comme brouillon',
    submitToMFiles: 'Soumettre à MFiles',
    submitToEmail: 'Soumettre par courriel',
    submit: 'Soumettre',
    successfulMFiles: 'Soumis à M-Files avec succès!',
    successfulEmail: 'Courriel envoyé avec succès!',
    successfulSubmit: 'Soumis avec succès!',
    successfulSave: `Vous avez sauvegardé avec succès!`,
    partiallySuccessfulSubmit: 'Soumis partiellement avec succès',
    reviewMessages: 'Svp, passer en revue les messages suivants:',
    success: 'Réussi',
    partialSuccess: 'Partiellement réussi',
    failed: 'Échoué',
    didNotRun: 'Abandonné',
    pdf: 'PDF',
    email: 'Courriel',
    mFiles: 'M-Files',
    database: 'Base de données',
    fileStorage: 'Stockage de fichiers',
    confirmDelete: 'Confirmation de la suppression',
    deleteDraftWarning: 'Cela supprimera définitivement le brouillon',
    actionIrreversible: 'Cette action est irréversible.',
    deleteDraft: 'Souhaitez-vous supprimer le brouillon associé?',
    delete: 'Supprimer',
    projectNotSelected: "Aucun projet n'a été sélectionné",
    failedMFiles: 'Échec de la soumission à M-Files 😢',
    failedEmail: "Échec de l'envoi du courriel 😢",
    failedSubmit: "Échec d'une ou plusieurs opérations 😢",
    tryAgain: "Malheureusement, une erreur s'est produite. Souhaitez-vous réessayer?",
    retry: 'Réessayer',
    drafts: 'Brouillons',
    yes: 'Oui',
    no: 'Non',
    ok: 'Ok',
    reset: 'Réinitialiser',
    cancel: 'Annuler',
    close: 'Fermer',
    clear: 'Effacer',
    confirm: 'Confirmer',
    add: 'Ajouter',
    location: 'Lieu',
    description: 'Description',
    suggestions: 'Suggestions',
    suggestionsAndMeasures: "Suggestions d'améliorations et de mesures correctives",
    selectAnOption: 'Choisir une option',
    exportToExcel: 'Exporter dans Excel',
    filters: 'Filtres',
    entries: 'Entrées',
    dateCreated: 'Date de création',
    type: 'Type',
    start: 'Début',
    end: 'Fin',
    any: 'Tous',
    status: 'Statut',
    edit: 'Modifier',
    closed: 'Complété',
    submittedToManager: 'Envoyé',
    active: 'En cours',
    verifiedUser: 'Utilisateur M-Files vérifié',
    verifiedProject: 'Projet M-Files vérifié',
    reportAnIssue: 'Signaler un problème',
    noResults: 'Aucun résultat',
    newNotification: 'notification{0} non lue{0}',
    markAs: 'Marquer comme',
    seen: 'lue',
    unseen: 'non lue',
    confidentiality: 'Confidentialité',
    nothingNew: "Il n'y a plus rien ici!",
    refresh: 'Rafraîchir',
    clearAll: 'Effacer tous',
    perPage: 'par page',
    subject: 'Sujet',
    from: 'De',
    to: 'À',
    fromTo: 'De / à',
    about: 'À propos',
    createdBy: 'Créé par',
    addComment: 'Commenter',
    hiddenComment: 'commentaires cachés',
    search: 'Rechercher',
    manager: 'Gestionnaire',
    skip: 'Passer',
    send: 'Envoyer',
    reply: 'Répondre',
    attachments: 'Pièces jointes',
    filePermited:
        'Vous pouvez joindre des fichiers: jpg, png, docx (Document Word), pdf, xlsx (document Excel), .pptx (PowerPoint) et txt.',
    badFiles: "SVP veuillez joindre des types de fichiers permis. Les fichiers suivants n'ont pas été joint:",
    badFilesOrSame:
        "Vérifier si le(s) fichier(s) existent déjà dans la liste, que la taille n'excède pas la limite, que les types de fichiers sont permis. Les fichiers suivants n'ont pas été joint:",
    deleteAnswerTitle: 'Supprimer la réponse?',
    deleteAnswerBody: 'Êtes-vous certain de vouloir supprimer cette réponse?',
    sessionExpired: 'Votre session a expiré. Veuillez actualiser la page avant de continuer.',
    sessionAboutToExpire:
        "Attention! Votre session est sur le point d'expirer. Veuillez sauvegarder vos modifications dès maintenant pour vous assurer de conserver vos derniers ajouts.",
    download: 'Télécharger',
    openMeeting: `Ouvrir rencontre`,
    downloadFile: 'Télécharger le fichier',
    showAll: 'Afficher tous',
    showPrevious: 'Afficher précédent',
    showLess: 'Afficher moins',
    answer: 'Ajouter une réponse',
    lastModified: 'Dernière modification',
    unsavedChanges: 'Vous avez des modifications non enregistrées, voulez-vous vraiment quitter?',
    downloadPdf: 'Télécharger le PDF',
    later: 'Plus tard',
    none: 'Aucun',
    firstname: 'Prénom',
    lastname: 'Nom de famille',
    telephone: 'Téléphone',
    office: 'Bureau',
    openHelpLinks: "Cliquer pour ouvrir le menu des liens d'aide",
    newVersionAvailable: 'Une nouvelle version du portail est disponible',
    employeeDevelopmentYear: 'Année de référence',
    completed: 'Complété',
    name: 'Nom',
    deletePart1: 'Êtes-vous sûr de vouloir supprimer',
    warning: 'Avertissement',
    synchronize: 'Synchroniser',
    hours: `Heures`,
    notApplicableShort: 'N/A',
    notification: 'Notifications',
    loadFilesError: `Le téléchargement du document n'a pas fonctionné. Veuillez réessayer.`,
    accessDenied: `Vous n'avez pas accès à ces informations ou votre session est expirée.`,
    selectYear: `Sélectionner une année`,
    meeting: {
        meetingStatus: [
            'Actif',
            'Complété',
            'Abandonné',
            `En attente`,
            'Soumis',
            'En révision',
            'Inactif',
            'Approuvé',
            'Fermé par défaut',
            'À faire',
        ],
        meetingCareer: ['Actif', 'Soumis', 'Complété', 'Commentaires post-rencontre', 'Fermé par défaut', 'À faire'],
    },
    sections: {
        disabledSection: 'Application fermée',
        referenceYear: 'Années de référence',
        mandatoryObjective: `Objectif opérationnel`,
        individualObjective: `Objectifs personnalisés`,
        synergy: `Performance individuelle`,
        approbation: `Approbation requise`,
        subTitleApprobationOverall: `Votre rencontre d'appréciation globale terminée, vous devez maintenant approuver les données entrées. Si vous êtes d'accord avec le contenu du présent formulaire.
        Appuyez sur le bouton ci-bas!`,
        subTitleApprobationObjectif: `Votre rencontre d'objectifs annuels terminée, vous devez maintenant approuver les données entrées. Si vous êtes d'accord avec le contenu du présent formulaire.
        Appuyez sur le bouton ci-bas!`,
        careerJobLevel: 'Niveau RH',
        careerMeetingDetails: 'Date de la rencontre carrière',
        previousOverallAssessement: 'Rencontres appréciation globale précédentes',
        yearOverView: 'Réflexion ouverte sur votre année chez BBA',
        objectiveReview: "Révision de vos objectifs de fin d'année",
        parhMembers: 'Employé(e)s de mon rôle PARH',
        departmentMembers: 'Autres membres de mes équipes',
        reminder: 'Important',
        enddingQuestion: 'Autre',
        emailNotification: "M'informer des nouvelles notifications par courriel pour les sections suivantes :",
        preferences: 'Préférences de compte',
        personalInfo: 'Information personnelle',
        employeeDetails: "Détails de l'employé",
        identifyTask: 'Identifier la tâche',
        styleMapping: 'Association des styles',
        MFilesFieldMapping: 'Association des champs MFiles',
        thinkAboutTheTask: 'Réfléchir à la tâche',
        riskAssessment: 'Évaluer les risques',
        assessGoldenRule: "Vérification des règles d'or",
        relatedProject: 'Projet rattaché',
        attachFiles: 'Joindre des fichiers',
        selectDocuments: 'Sélection de(s) document(s)',
        confirmTaskSafety: 'Confirmer la sécurité de la tâche',
        eventType: "Type d'événement",
        whatHappened: "Que s'est-il produit?",
        whatAreYouDoing: 'Que faites-vous?',
        whoIsThisFor: 'À qui vous adressez-vous?',
        interventionDetails: "Détails de l'intervention",
        riskAssessmentOfChanges: 'Évaluation des risques du changement',
        activityManagement: 'Gestion des activités',
        activityRegister: 'Registre des activités',
        hseMinutes: 'Minutes SSE',
        activityExtraProfessional: 'Activité extra-professionnelles',
        activityCommittee: 'Activité de comité',
        feedbacks: 'Rétroactions',
        receivedRequests: 'Demandes en attente',
        provideFeedback: 'Fournir une rétroaction',
        feedbackDetails: 'Détails de la rétroaction',
        registerGuest: "S'enregistrer",
        watchVideo: 'Écouter la vidéo',
        watchVideoOptional: 'Écouter la vidéo (facultatif)',
        enterEmail: 'Entrer votre courriel',
        visitorHistory: 'Historique des visiteurs de la journée',
        manageNearmisses: 'Gestion des quasi-incidents',
        previousFollowUps: 'Rencontres de suivi précédentes',
        previousObjectives: `Rencontres d'objectifs annuels précédentes`,
        mobilisation: 'Mobilisation',
        bbaValues: 'Valeurs BBA',
        followUpDetails: 'Détails de la rencontre',
        establishMyObjectives: 'Établir mes objectifs',
        teamMembers: 'Membres de mon équipe immédiate',
        dashboardAndMetrics: 'Tableau de bord et métriques',
        technicalSkills: 'Compétences techniques',
        peopleSkills: 'Compétences interpersonnelles',
        developmentTracks: 'Pistes de développement (Court terme)',
        previousCareers: 'Rencontres de carrière précédentes',
        careerPath: 'Cheminement de carrière / axe de développement',
        careerPathSubtitle:
            "Il s'agit d'évaluer l'employé.e selon ses responsabilités (poste et rôle.s occuppé.s, s''il y a lieu) et ce, pour le ou les axe.s BBA applicable.s. Employé comme gestionnaire positionnent donc le curseur sur le continuum selon leur propre perspective.",
        careerProgress: 'Évolution de carrière',
        introspection: 'Introspection',
        disciplineObjectives: 'Objectifs stratégiques',
        roleObjectives: 'Objectifs de rôle',
        positionObjectives: 'Objectifs de poste',
        objectivesType: "Type d'objectifs",
        objectiveDetails: "Détails de l'objectif",
        comments: 'Commentaires',
        importDocument: 'Importation des documents',
        viewingProfile: "Affichage de l'employé",
        covidIdentication: 'Identification',
        covidQuestionnaire: 'Questionnaire',
        covidSummary: 'Sommaire',
        employeeNotes: "Notes sur l'employée (confidentiel pour gestionnaires + PARH)",
        covidFormList: 'Liste des déclarations COVID-19',
        careerDevelopmentObjective: 'Objectifs de développement',
        introspectionRequiredQuestion: 'Questions - obligatoires',
        introspectionOptionalQuestion: 'Questions additionnelles - supplémentaires',
        careerReturnOnDevelopmentActivities: "Retour sur activités de développement de l'année courante",
        careerReturnOnDevelopmentActivitiesSubtitle:
            "Voici une liste comprenant plusieurs pistes de développement qui peuvent être sélectionnée en regard de ce qu'il a eu comme parcours au courant de l'année.",
    },
    comments: {
        showing: 'Affichage de',
        of: 'sur',
        comment: 'commentaire',
        comments: 'Commentaires',
        commentsDescription: 'Commentaires/description',
        enterComments: 'Entrez vos commentaires ici',
    },
    notifs: {
        feedbackRequestTitle: 'Demande de rétroaction',
        feedbackRequestBody: '{0} vous a envoyé une demande de rétroaction sur {1}.',
        newFeedbackTitle: 'Nouvelle rétroaction',
        newFeedbackBody: '{0} vous a envoyé une rétroaction.',
        feedbackNotifyTitle: 'Avis de rétroaction',
        feedbackNotifyBody: '{0} a envoyé une rétroaction à {1}.',
        objectiveSendToManagerTitle: "Avis d'employé·e sur leurs objectifs",
        objectiveSendToManagerBody: '{0} vous avise à propos de leurs objectifs prêts a être figé',
        objectiveNewCommentTitle: 'Nouveau commentaire',
        objectiveNewCommentBody: '{0} a ajouté un commentaire sur un objectif.',
        objectiveChangedTitle: 'Objectif modifié',
        objectiveChangedBody: "{0} a modifié la description d'un objectif.",
        objectiveFreezeTitle: 'Objectifs figés',
        objectiveFreezeBody: "{0} a figé ses objectifs pour l'année courante.",
        followUpNewCommentTitle: 'Nouveau commentaire',
        followUpNewCommentBody: '{0} a ajouté un commentaire dans la rencontre de suivi.',
        followUpFreezeTitle: 'Rencontre de suivi figée',
        followUpFreezeBody: '{0} a figé sa rencontre de suivi active.',
        followUpSendToManagerTitle: "Avis d'employé·e sur sa rencontre de suivi",
        followUpSendToManagerBody: '{0} vous avise à propos de sa rencontre de suivi qui a bientôt lieu',
        careerSendToManagerTitle: "Avis d'employé·e sur sa carrière",
        careerSendToManagerBody: '{0} vous avise à propos de sa rencontre carrière qui a bientôt lieu',
        overallAssessmentSendToManagerTitle: `Avis d'employé·e sur sa rencontre d'appréciation globale`,
        overallAssessmentSendToManagerBody: `{0} vous avise à propos de sa rencontre d'appréciation globale qui à bientôt lieu`,
        overallAssessmentAskRevisionTitle: `Votre employé·e veux réviser sa rencontre`,
        overallAssessmentAskRevision: `{0} vous avise qu'il·elle veut ajouter du contenu à sa rencontre d'appréciation globale. Allez dans la section approbation pour réactiver la rencontre`,
        objectiveAskRevisionTitle: `Votre employé·e veux réviser sa rencontre`,
        objectiveAskRevision: `{0} vous avise qu'il·elle veut ajouter du contenu à sa rencontre d'objectif annuel. Allez dans la section approbation pour réactiver la rencontre`,
        objectiveApprobationRequiredTitle: `Votre approbation est requise.`,
        objectiveApprobationRequiredBody: `{0} a approuvé et figé vos objectifs. SVP, passez-les en revue et si vous êtes en accord, approuvez-les en bas de page. Sinon, demandez une révision.`,
        overallApprobationRequiredTitle: `Votre approbation est requise.`,
        overallApprobationRequiredBody: `{0} a approuvé et fermé votre Appréciation globale. Passez en revue le contenu et si vous êtes en accord, approuvez en bas de page. Sinon demandez une révision.`,
    },
    task: {
        task: 'Tâche',
        tasks: 'Tâches',
        newTask: 'Nouvelle tâche',
        createTask: 'Créer une tâche',
        editTask: 'Modifier une tâche',
        enterTaskName: 'Entrer le nom de la tâche (obligatoire)',
        controlsImplemented: "J'ai mis en place les contrôles pour tous les risques identifiés.",
        risksControlled: 'Je peux effectuer la tâche en toute sécurité. À ma connaissance, tous les risques sont maîtrisés.',
        consultSupervisor: "Je ne suis pas sûr et je consulterai mon superviseur pour identifier d'autres contrôles.",
        controlsToImplement: 'Quels contrôles doivent être mis en place?',
    },
    nearmiss: {
        nearmiss: 'Quasi-incident',
        nearmisses: 'Quasi-incidents',
        deleteEntry: "Supprimer l'entrée?",
        confirmDelete: 'Vous êtes sur le point de supprimer cette entrée de façon définitive.',
    },
    intervention: {
        closedSection: `L'application pour l'intervention système à distance n'est plus accessible, le 
        formulaire d'analyse de risques a été modifié afin d'utiliser ce dernier pour les interventions à distance. Le formulaire est accessible via M-File.`,
        chooseTitle: 'Donnez un titre à votre intervention',
        plannedDuration: 'Durée planifiée (en jours)',
        theEmail: "L'adresse courriel",
        appearsInvalid: 'ne semble pas valide, veuillez réessayez.',
        selectExistingClient: 'Sélectionnez un client existant',
        orFillManually: 'ou remplir manuellement',
        projectClientRepresentative: 'Représentant du client pour le projet',
        problemClientRepresentative: 'Représentant du client en cas de problème (facultatif)',
        interventionManager: "Responsable de l'intervention",
        discipline: 'Discipline',
        sendToRecipients: 'Envoyer aux destinataires (facultatif)',
        spaceSeparatedEmails: 'Entrez le(s) adresse(s) courriel séparée(s) par des espaces',
        rememberClient: 'Se souvenir des informations du client',
        overwriteClientWarning: 'Écrasera tout client existant avec le même nom et le même emplacement.',
        objectives: 'Quels sont les objectifs?',
        isPlanned: "L'intervention était-elle planifiée?",
        planned: 'Planifiée',
        unplanned: 'Non planifiée',
        technicalAssistance: 'Assistance technique',
        planLink: 'Lien vers le plan',
        revisedByHseIntegrator: "Revu par l'intégrateur SSE",
        periodCoveredInDays: "Période couverte en jours (jusqu'à 7)",
        unfamiliarType: "Je ne suis pas familié avec le type d'intervention",
        areYourFamiliar: "Êtes-vous familié avec le type d'intervention?",
        revisedBy: 'Revu par',
        systemName: 'Nom du système (facultatif)',
        systemTypes: 'Type(s) de système',
        environments: 'Environnement(s)',
        interventionLocation: "À partir de quel endroit s'effectue l'intervention?",
        localIntervention: 'Directement chez le client',
        remoteIntervention: 'Hors du périmètre du client',
        connectionUsed: 'Connexion utilisée',
        loginCredentials: 'Domaine\\usager',
        bbaEquipmentAllowed: "La connexion avec l'équipement BBA est-elle permise?",
        allocatedIP: 'Adresse IP allouée',
        followingClientProcess:
            "Est-ce que le client possède déjà un processus pour prévenir les risques d'une intervention système à distance?",
        addRisk: 'Ajouter un risque',
        risk: 'Risque',
        criteria: 'Critère',
        probability: 'Probabilité',
        gravity: 'Gravité',
        mitigationMeans: 'Moyens de mitigations',
        almostCertain: 'Presque certain',
        highProbability: 'Élevé',
        averageProbability: 'Moyen',
        lowProbability: 'Faible',
        highGravity: 'Élevé',
        averageGravity: 'Moyen',
        lowGravity: 'Faible',
        lowRisk: 'Risque faible',
        averageRisk: 'Risque moyen',
        highRisk: 'Risque élevé',
    },
    activities: {
        redirectManagementLog: 'Les activités reliées aux <u>rapports mensuels de direction SSE</u> sont maintenant <a href="https://forms.office.com/r/ik5mqtHJSf">ici</a>.',
        attributableOffice: 'Bureau imputable',
        committeeType: 'Type de comité',
        activityType: "Type d'activité",
        activity: 'Activité',
        numberOfParticipants: 'Nombre de participants',
        activityDescription: "Description de l'activité",
        otherInformationOptional: 'Autres informations (facultatif)',
        addMoreDetails: "Ajouter plus d'info",
        relatedDocumentsOptional: 'Présentation(s) ou document(s) connexe(s) (facultatif)',
        participants: 'Participants',
        enterParticipantName: "Entrez le nom d'un participant et cliquez sur ajouter",
        addParticipant: 'Ajouter le participant',
        noParticipant: 'Aucun participant ajouté',
        topicsCovered: 'Sujet(s) couvert(s)',
        addActivity: 'Ajouter une activité',
        deleteActivity: "Supprimer l'activité",
        details: 'Détails',
        initiativeDescription: "Description de l'activité/initiative",
        formSelection: 'Choix du formulaire',
        orJoinList: 'ou joindre une liste ci-dessous',
        exportedActivities: 'ActivitésExportées',
    },
    feedbacks: {
        yearReferenceSubtitle:
            "Veuillez choisir une année antérieure dans le menu déroulant ci-bas pour afficher vos rétroactions en lien avec cette année de référence! Par défaut c'est l'année en cours qui est choisie!",
        criteria: 'Critère de rétroaction',
        error: "Veuillez donner une valeur correspondante à votre commentaire en cliquant directement sur l'axe gradué.",
        average: 'Moyenne',
        atLeastOneSubject: 'Vous devez cocher au moins un sujet',
        feedbacks: 'Rétroactions',
        noRecived: `Il n'y a aucune rétroaction reçue pour l'instant!`,
        noSended: `Il n'y a aucune rétroaction envoyé pour l'instant!`,
        noRequestRecived: "Vous n'avez aucune requête de rétroaction reçu pour l'instant",
        noRequestSended: "Vous n'avez aucune requête de rétroaction envoyé pour l'instant",
        submitConfirmTitle: 'Envoyer la rétroaction?',
        submitConfirmOnlyManager: 'Votre rétroaction sera uniquement envoyée au gestionnaire de {0}.',
        submitConfirmBothEmployees: 'Votre rétroaction sera envoyée à {0} et à son/sa gestionnaire.',
        submitSuccessBody: 'Votre rétroaction a été envoyée avec succès.',
        submitFeedback: 'Envoyer la rétroaction',
        searchFeedback: 'Chercher une rétroaction',
        newFeedback: 'Nouvelle rétroaction',
        newRequest: 'Nouvelle requête de rétroaction',
        sendRequestTo: 'Envoyer une demande de rétroaction à',
        onEmployee: "Sur l'employé",
        managerOnly: 'Gestionnaires seulement',
        employeeCanView: "Visible pour l'employé",
        informManagerOnly: 'Seulement informer le gestionnaire',
        onlyShowReceived: 'Afficher reçu seulement',
        feedbackSent: 'Rétroaction envoyée',
        feedbackReceived: 'Rétroaction reçue',
        tooltipContextTitle: 'Mise en contexte',
        tooltipContext:
            'Détailler le contexte de votre rétroaction en précisant, les intervenants impliqués, le projet, les livrables, le lieu, le moment, etc.',
        tooltipObservableFactsTitle: 'Faits observables',
        tooltipObservableFacts:
            'Détailler comment la personne a agi, le comportement observable, la qualité des livrables, etc. (attention à ne pas mentionner de perceptions)',
        tooltipImpactsTitle: 'Impacts des faits sur le projet/opérations',
        tooltipImpacts: 'Préciser comment les faits mentionnés ci-haut ont impacté les opérations/le projet',
        tooltipRecommendationsTitle: 'Recommandations (si applicable)',
        tooltipRecommendations:
            "Au besoin, donner à l'employé des conseils pour faire rayonner l'effet positif du comportement ou préciser des pistes d'améliorations pour mieux traiter cette situation dans le futur",
        received: 'Reçues',
        sent: 'Envoyées',
        filters: 'Filtres',
        yourRelationship: 'Détails sur votre relation',
        sendingAsRole: 'Rétroaction émise par',
        receiveAsRole: 'Rétroaction reçue pour le rôle de',
        sentAsRole: 'Envoyé en tant que',
        receivedAsRole: 'Reçu en tant que',
        cancelRequestTitle: 'Annuler la demande?',
        cancelRequestBody: "La demande de rétroaction envoyée à {0} sera supprimée. Au besoin, il est possible d'en recréer une nouvelle.",
        projectSelector: `<p>Projet-Client(facultatif)
        <span style="font-size: 13px">
        Attention : le projet doit exister dans la voûte Projet client de M-Files pour fonctionner. Un icône de bouclier vert 
            <span class='material-symbols-outlined'>verified_user</span> doit être visible pour signifier que le projet est
            valide.
        </span></p>`,
        employeeSelector: `<p>Employé·e·s</p>
        <p style="font-size: 13px">Veuillez noter que, dorénavant, vous pouvez envoyer la même rétroaction à plusieurs personnes en même temps.
        <b>Cependant, si le nombre de personnes sélectionnées est élevé, le traitement sera plus long</b> lorsque vous appuierez sur Envoyer.</p>
        <p style="font-size: 13px"><b>Maximum 10 employé·e·s</b></p>`,
    },
    followUp: {
        meetingDateRequired: "Vous devez spécifier une date.",
        yearReferenceSubtitle:
            "Veuillez choisir une année antérieure dans le menu déroulant ci-bas pour afficher vos rencontres de suivi en lien avec cette année de référence! Par défaut c'est l'année en cours qui est choisie!",
        importantTitle: 'AVIS IMPORTANT – Rencontre de suivi',
        importantText: `Les questions énumérées dans les différentes sections du formulaire sont facultatives et servent de guide pour alimenter votre discussion (atteinte des objectifs, mobilisation, valeurs, etc.).`,
        importantText2: ` Compléter seulement celles que vous jugez pertinentes au moment de la rencontre qui se veut avant tout un moment pour prendre le pouls et échanger sur ce qui est important pour vous.`,
        noFollowUp: `Il n'y a aucune rencontre de suivi pour l'instant!`,
        submitSuccessBody: `Votre suivi a été envoyé avec succès à votre gestionnaire et a été sauvegardé.`,
        targetInformation: 'Question ouverte',
        targetParagraph: "Discussion ouverte sur éléments interne/externe pouvant ayant de l'impact sur la performance",
        enddingQuestionTitle: 'Autre',
        objective: 'Revue des Objectifs',
        feedback: 'Revue des Rétroactions',
        objectifReview:
            "Profitez de l'occasion pour revoir vos objectifs annuels, mettre à jour leur niveau de complétion et commenter au besoin.",
        feedbackReview:
            "Profitez de l'occasion pour revoir vos dernières rétroactions reçues (identifier pistes d'amélioration potentielles s'il y a lieu)",
        followUp: 'Suivi',
        createAppointment: 'Créer un rendez-vous Outlook',
        addToOutlook: 'Ajouter à Outlook',
        followUps: 'Rencontres de suivis',
        submitFollowUp: 'Soumettre la rencontre',
        outlookFileName: `Invitation - Rencontre de SUIVI Mon Parcours BBA - ([EmployeeName])`,
        followUpTitle: `Invitation - Rencontre de SUIVI Mon Parcours BBA - ([EmployeeName])`,
        followUpDescription: `<p>Bonjour,</p>
        <p>Mon Parcours BBA est le programme qui permet d'apprécier la contribution individuelle annuelle des employés.</p>        
        <p>Voici une invitation à une Rencontre de suivi au cours de laquelle des éléments en regard des critères de performance de [Employee] seront abordés.</p>
        <ul>    
        <li>Évolution des objectifs annuels</li>    
        <li>Retour sur rétroactions reçues</li>    
        <li>Mobilisation</li>
        <li>Valeurs BBA (respect / non-respect)</li>   
        <li>Compétences techniques (maîtrise/non-maîtrise)</li>    
        <li>Compétences interpersonnelles (maîtrise/non-maîtrise)</li>    
        <li>Pistes de développement court-terme</li>    
        <li>Autres éléments ayant de l'impact sur la contribution annuelle</li></ul>    
        <p>Lors de cette rencontre, ce sera une excellente occasion de mettre en lumière les bons coups et de discuter des points d'améliorations.
         La discussion sera aussi axée sur la progression et le réalignement des attentes, si le tout si jugé nécessaire.</p>    
        <p>À la suite de cette rencontre, un document Rencontre de suivi de performance (RSP) sera produit en pdf et consolidé au dossier de l'employé.
         Pour de plus amples détails, rendez-vous sur la page Mon Parcours en cliquant 
         <a href="https://intranet.bba.ca/sites/talent-development/SitePageModern/2172/my-bba-journey">ici</a>.
          De plus, vous pouvez vous référer au <a href="https://intranet.bba.ca/sites/practical-information/faq-portal/faq/3520/faq_which-time-code-do-i-need-to-use-for-my-bba-journey-meetings-and-engagement-activities">Tableau des codes de charge</a>
           pour savoir où charger le temps consacré à la préparation et aux rencontres.</p>
        <p>Merci de votre collaboration et n'hésitez pas à consulter votre gestionnaire ou PARH en cas de questions.</p>
            <p>Bonne journée!</p>    
            <p>Service des Ressources humaines</p>`,
        newFollowUp: 'Nouvelle rencontre de suivi',
        openTool: "Ouvrir l'outil",
        noTechnicalSkill: "Vous n'avez pas encore ajouté de compétences techniques.",
        noPeopleSkill: "Vous n'avez pas encore ajouté de compétences interpersonnelles.",
        noDevelopmentTrack: "Vous n'avez pas encore ajouté de piste de développement.",
        mobilisationDesc:
            "Cette section doit être complétée par l'employé seulement. Il s'agit de questions, non obligatoires, qui doivent être sélectionnées au choix par l'employé, et qui invite l'employé à réfléchir en regard de sa propre mobilisation au travail. Les réponses à celles-ci peuvent être partagées au gestionnaire.",
        bbaValuesDesc:
            "Il s'agit des valeurs que BBA prônent au quotidien. L'employé comme son gestionnaire peuvent venir documenter cette section en ajoutant des faits, projets, comportements adoptés par l'employé ou encore toute situation vécue qui démontrent le respect ou encore le non-respect de celles-ci.",
        technicalSkillsDesc:
            "En référence à l'outil de gestion des compétences techniques développé par Pratique, identifiez ici les compétences techniques méritant d'être soulignées dans le suivi de performance individuelle de l'employé en raison de la maîtrise ou de la non maîtrise de la/les compétence.s concernée.s. L'employé comme son gestionnaire peuvent venir documenter cette section en ajoutant des faits, projets, comportements adoptés par l'employé ou encore toute situation vécue qui démontrent le respect ou encore le non-respect de celles-ci.",
        peopleSkillsDesc:
            "En référence à l'outil Référentiel compétences interpersonnelles apparaissant dans le menu déroulant ci-bas, l'employé a adopté un/des comportement.s lié.s à une/des compétence.s de savoir-être et méritant d'être souligné dans le suivi de performance individuelle de l'employé en raison de la maîtrise ou de la non maîtrise de la/les compétence.s concernée.s. L'employé comme son gestionnaire peuvent venir documenter cette section en ajoutant des faits, projets, comportements adoptés par l'employé ou encore toute situation vécue qui démontrent le respect ou encore le non-respect de celles-ci.",
        developmentTracksDesc: `Pistes d'actions concrètes de développement qui permettront à l'employé de s'améliorer dans une tâche, un projet ou en regard des comportements qu'il adopte en général. Ceci, dans un horizon à ${`court terme`.toUpperCase()} afin de corriger rapidement une situation. Il peut s'agir de formations, d'ateliers, de lectures, de coaching, de parrainage, etc.`,
        previousAnswersHistory: 'Historique de réponses précédentes',
        showHistory: "Afficher l'historique",
        plannedDate: 'Date de la rencontre',
        attentionOutlook: `Veuillez cocher l'option ci-haut pour générer une invitation d'une rencontre Outlook à l'instant (vous pourrez le faire ultérieurement également).`,
        attentionOutlook2: `Notez que si la date sur la rencontre Outlook est modifiée, celle-ci ne sera pas mise à jour dans Mon Parcours BBA.`,
        closeFollowUp: 'Fin de rencontre',
        peopleSkillName: 'Compétence interpersonnelle',
        technicalSkillName: 'Compétence technique',
        developmentTrackName: 'Piste de développement',
        provideDetails: 'Veuillez fournir plus de détails',
        deleteTechnicalSkill: 'Supprimer la compétence technique?',
        confirmDeleteTechnicalSkill: 'Cela supprimera la compétence technique de façon définitive.',
        deletePeopleSkill: 'Supprimer la compétence interpersonnelle?',
        confirmDeletePeopleSkill: 'Cela supprimera la compétence interpersonnelle de façon définitive.',
        deleteDevelopmentTrack: 'Supprimer la piste de développement?',
        confirmDeleteDevelopmentTrack: 'Cela supprimera la piste de développement de façon définitive.',
        confirmFreezeTitle: 'Figer la rencontre de suivi?',
        confirmFreezeBody: `Cette action va figer la rencontre de suivi et va générer un document sommaire dans M-Files.`,
        objectivesReminderTitle: 'Aller aux objectifs?',
        objectivesReminderBody:
            "Votre rencontre de suivi est maintenant complétée. Profitez de l'occasion pour revoir vos objectifs annuels, mettre à jour leur niveau de complétion et commenter au besoin.",
        answersHistory: 'Historique des réponses',
        strength: 'Force',
        opportunity: 'Élément à améliorer',
        submitSuccessBodySave: `Votre rencontre de suivis a été sauvegardée. Vous allez être redirigé·e vers la page d'accueil des suivis!`,
        submitSuccessBodySaveManager: `La rencontre de suivis de votre employé·e a été sauvegardée. Vous allez être redirigé·e vers la page d'accueil de suivis de votre employé·e!`,
        followUpStatusLegendExplanation: [
            `Il est possible d’entrer des informations pour un suivi de la performance de l’employé·e.`,
            `La rencontre de suivi entre l’employé·e et son gestionnaire a eue lieu.`,
            ``,
            ``,
            `L'employé·e à avisé son gestionnaire qu’il·elle est prêt·e pour une rencontre de suivi.`,
            '',
            '',
            '',
            'La rencontre et le processus d’approbation n’ont pas été complété dans les délais requis.',
        ],
    },
    objectives: {
        ops: `Opération`,
        tl: `Chef·fe d'équipe`,
        dm: `Chef·fe de service`,
        od: `Directeur·rice de bureau`,
        opsObjectiveTarget: `Heures cibles facturables - Clients Projets`,
        opsObjectiveWeight: `Poids de l'objectif facturable`,
        opsObjectiveNb: `# d'objectif`,
        submitSuccessBody: `Votre gestionnaire a bien été notifié·e. Vous allez être redirigé·e vers la page d'accueil.`,
        explainationTarget: `Cette valeur est modifiable seulement par ton gestionnaire.
        Elle sera également figée lors de l'appeobation des deux parties des objectifs`,
        objectiveTarget: `Heures cibles révisées`,
        justification: `SVP, veuillez justifier la raison du changement en regard de la cible:`,
        warningfreezeObjectif: `La fixation des objectifs sera ouverte aux gestionnaires à la suite de l’exercice de révision salariale. (Mi-mars)`,
        sectionClosed: "À ce moment-ci du cycle, veuillez voir le module d'appréciation globale!",
        HrFamily: 'Niveau RH',
        qutObjectives: "Combien d'objecifs",
        weightTooltip: "Poids de l'objectif opérationnel",
        displayObjective: "Voir la liste du nombre d'objectifs par niveau RH",
        displayWeight: 'Voir la liste du poids pour votre objectif opérationnel si vous êtes membre département des opérations.',
        becauseReview: `La demande de révision est pour permettre d'ajouter des commentaires ou des fichiers attachés à une rencontre d'objectif annuel. En appuyant sur le bouton une notification 
        sera envoyé à votre gestionnaire pour qu'il·elle réouvre la rencontre.`,
        becauseReviewManager: `Parce que votre employé·e vous demande de réouvrir la rencontre d'objectifs annuels dans le but d'y ajouter du contenu.
        Ou bien, vous desirez en changer le contenu avant que les deux parties aient approuvés.`,
        warningApproval: `ATTENTION! Le processus d'approbation devra être recommencé.`,
        approbationEmployee: `Approuver vos objectifs`,
        approbationManager: `Approuver les objectifs de votre employé·e`,
        nbObjective: `Objectifs totaux requis`,
        nbObjectiveTitle: `Quantité d'objectif à remplir`,
        nbObjectiveExplaination: `Voici le nombre d'objectif que vous avez besoin en lien avec le niveau RH que vous avez au sein de BBA.`,
        nbObjectiveActive: `Objectif(s) courant(s)`,
        soloPerformence: `Performance individuelle`,
        soloPerformenceTitle: `Votre calcule de performence pour vos objectifs individuels`,
        soloPerformenceExplaination: `Comme les objectifs obligatoire leur performence N'EST PAS calculer avant la fin de l'année. Ce calcule se base uniquement sur vos objectifs individuels.
        Ceci est a titre indicatif seulement et passible de révision par le gestionnaire `,
        commentTitle: `Attention à votre commentaire`,
        commentNotSaved: `Vous avez écrit un commentaire que vous n'avez pas envoyé.`,
        saveComment: `Sauvegarder votre commentaire`,
        cancelComment: `Ne pas envoyer votre commentaire`,
        noObjectives: `Vous n'avez pas d'objectifs pour cette catégorie.`,
        detail: "Détails de l'objectif",
        retroaction: 'Rétroaction',
        status: "Statut de l'objectif",
        readOnly: 'Mode lecture seulement',
        lastjobLevel: `Niveau RH de l'an passée : `,
        newJobLevel: `Niveau RH de cette année : `,
        managerTitle: `Titre de gestionnaire : `,
        groupSize: `Taille de votre groupe : `,
        group: `Votre groupe : `,
        roleInformation: "Prendre note que certains rôles peuvent affecter le % de la cible et d'autres non",
        targetParagraph:
            "NOTE : Cette cible sera atteinte si BBA dépasse le seuil minimal de profitabilité et si l'employé relève tous ses défis.",
        targetInformation: "Conditionnel à l'atteinte des critères d'admissibilté dans l'année en cours.",
        objectivesHeaders: 'Objectif(s)',
        targetParagraphSynergy: "Information relative à la cible qui était applicable lors de l'année antérieure, s'il y a lieu.",
        targetInformationSynergy: 'Cible année antérieure',
        targetParagraphSynergyCurrent: "Conditionnelle à l'admissibilité pour Synergie. Vous sera communiquée à la mi-mars.",
        targetInformationSynergyCurrent: 'Cible année en cours',
        objectives: 'Objectifs annuels',
        objectiveText: 'Objectif',
        myBbaJourney: 'Mon parcours BBA',
        completion: 'Complétion',
        weight: 'Poids',
        weightTotal: 'Poids total',
        disciplineObjectives: 'Projets liés aux objectifs stratégiques',
        roleObjectives: 'Objectifs de rôle',
        positionObjectives: 'Objectifs de poste',
        newObjective: 'Nouvel objectif',
        editObjective: "Modifier l'objectif",
        addObjective: 'Créer objectif',
        freezeObjectives: 'Figer les objectifs',
        noObjectiveYet: "Vous n'avez pas encore créé d'objectif de ce type.",
        freezeDateNotice: `Vos objectifs ${new Date().getFullYear()} ont étés figés le {0}.`,
        freezeRefused: "Vos objectifs n'ont pas été approuvés.",
        confirmFreezeTitle: 'Figer les objectifs?',
        confirmFreezeBody: `Cette action va figer tous les objectifs ${new Date().getFullYear()} et va démarrer l’étape de signature à même Mon Parcours BBA qui devra être signé par l'employé·e.`,
        disciplineObjectivesDetails: `Aller au-delà des performances professionnelles habituelles requises pour les tâches quotidiennes. Relever des défis ambitieux. Inciter l’employé à se surpasser. Contribuer à la réalisation des objectifs stratégiques de la BBA; cela implique la participation de l’employé à des projets, à des comités et à des groupes de travail dans le cadre du programme de leadership.`,
        refreezeSuccessTitle: 'Envoyé à M-Files avec succès!',
        refreezeSuccessBody:
            'Une nouvelle version du document PDF a été générée dans M-Files et doit être signée. Une fois signée, celle-ci sera réassignée à votre gestionnaire pour approbation.',
        roleObjectivesDetails: `Objectifs liés à un ou plusieurs rôle·s opérationnel·s. Peuvent correspondent à des apprentissages ou une amélioration requise pour l'évolution de l'employé·e.`,
        positionObjectivesDetails: `Objectifs liés à la performance régulière de travail. Réfèrent à des tâches quotidiennes  et/ou la description de poste. Peuvent correspondent à des apprentissages ou une amélioration requise pour l'évolution de l'employé·e.`,
        deleteObjective: "Supprimer l'objectif",
        confirmDeleteText: "Cette action supprimera définitivement l'objectif et ne peut pas être annulée.",
        markObsoleteTitle: 'Marquer comme obsolète?',
        markObsoleteText:
            "Il ne vous est pas permis de supprimer un objectif puisque vos objectifs sont figés. Cependant, il est possible d'identifier cet objectif comme étant obsolète.",
        restoreObjective: "Restaurer l'objectif",
        confirmDeleteFileTitle: 'Retirer le fichier joint?',
        confirmDeleteFileBody: "Cette action supprimera définitivement le fichier joint '{0}'.",
        roles: 'Rôles',
        result: 'Résultat',
        target: 'Cible',
        pastTarget: `Cible de l'an passé`,
        currentTarget: 'Cible actuelle',
        performance: 'Performance totale',
        performanceSynergy: 'Performance individuelle totale',
        saveRoles: 'Sauvegarder les rôles',
        weightSumWarningTitle: `***Attention, la performance individuelle globale sera communiquée en fin d'année lors de l'Appréciation globale.`,
        weightSumWarning: "La performance ne peut pas être calculée si la somme des poids de vos objectifs n'est pas égale à 100.",
        exportedObjectives: 'Objectifs exportés',
        exportAllObjectives: 'Exporter tous les objectifs',
        rolesArray: [
            `CCC + ventes > 500K$`,
            `Chef équipe de 5 employés et +`,
            `Intégrateur(rice)`,
            `Référence technique`,
            `Directeur(rice) de projet / 500K$`,
            `Ventes > 500K$`,
        ],
        objectivesStatus: ['Nouvel', 'Désuet', 'Modifié', 'Approuvé', 'Brouillon', 'Supprimé', 'Restauré'],
        objectiveStatusLegendExplanation: [
            `Il est possible d’entrer des informations relatives aux objectifs annuels.`,
            `La rencontre est maintenant fermée. SVP, voir l’Appréciation globale.`,
            ``,
            `Il manque l’une ou l’autre des signatures.`,
            `L'employé·e à avisé son gestionnaire qu’il·elle est prêt·e pour la rencontre Objectifs annuels.`,
            `Le gestionnaire a procédé à la ré-ouverture de la rencontre.`,
            ``,
            `Les deux parties ont signés les objectifs.`,
            `La rencontre et le processus d’approbation n'ont pas été complété dans les délais requis.`,
        ],
        synergyWarningDescription: `<h6 style="height:2.5rem; color: red;">***Important</h6>
        <p style="height:2.5rem; color: red;">Si vous voyez une valeur dans cette fenêtre qui est égale à -1 ou bien N/A.
         Veuillez communiquer avec votre PARH afin que nous puissions investiguer votre dossier.</p>`,
        operationalObjectiveDescription: `<h6 style="height:2.5rem;">***Cet objectif apparaîtra au profil des employé·e·s admissibles à Synergie, dès la mi-mars suite au processus de révision salariale.</h6>
        <p>
            Objectif pour une année donnée et applicable à tous les employés issus des opérations (non applicable pour les Services
            partagés). Cet objectif est <u>imposé</u> par la firme et <u>n’est pas modifiable durant l’année</u> par l’employé·e, 
            au niveau de la description, du poids attribué ou encore du % de complétion.
        </p>
        <h6>
            Important à savoir: Le niveau RH de l’employé·e est directement lié au poids de l’objectif. Ce poids sera donc variable
            entre 30% et 50% du poids total.
        </h6>`,
        individualObjectiveDescription: `<p>
        À établir spécifiquement pour l’employé·e et doivent être alignés avec la méthodologie SMARTS. Ceux-ci peuvent faire
        référence à :
        </p>
        <ul>
            <li>La performance régulière de travail.</li>
            <li>Un ou plusieurs rôle·s opérationnel·s.</li>
            <li>Projets ou mandats sur lequel l’employé·e sera appelé à collaborer durant l’année.</li>
            <li>Des tâches quotidiennes. </li>
            <li>La description de poste. </li>
            <li>Des apprentissages et/ou une amélioration requise pour l'évolution de l'employé·e.</li>
        </ul>
        <p>
            Ces objectifs sont modifiables tant au niveau de la description, du poids attribué ou encore du % de complétion. Ils seront
            appelés à évoluer tout au long de l’année (modification du % de complétion pour chacun selon l’avancement).
        </p>`,
        warningEligibilitySeptember: `<h5 style="color: red;">Important</h5>
        <p>Veuillez prendre note que les employé·e·s embauché·e·s le 1er septembre ou après ne sont pas éligibles à la prime Synergie pour l'année en cours.</p>`,
    },
    guests: {
        visitedEmployee: 'Nom de la personne visitée',
        associatedCompany: 'Compagnie associée',
        company: 'Compagnie',
        visiting: 'Rend visite à',
        checkedInSince: 'Enregistré depuis',
        checkedIn: 'Enregistré',
        checkedOut: 'Sorti',
        inOffice: 'Dans le bureau',
        outOfOffice: "À l'extérieur du bureau",
        forceCheckOut: 'Forcer la sortie',
        exportedGuests: 'RegistreVisiteurs',
        checkIn: "S'enregister",
        checkOut: "Retirer l'enregistrement",
    },
    employeeDetails: {
        username: "Nom d'utilisateur",
        fetchError: 'Impossible de récupérer les informations de profil.',
        name: 'Nom',
        email: 'Adresse courriel',
        title: 'Titre',
        office: 'Bureau',
        fullName: 'Nom complet',
    },
    account: {
        account: 'Mon compte',
        employeeNumber: "Numéro d'employé",
        jobTitle: 'Titre du poste',
        department: 'Département',
        officeLocation: 'Bureau de travail',
        offline: 'Vous êtes présentement hors-ligne',
    },
    appHeader: {
        subject: `Rapport de bogue`,
        bodyEmail: `Questions pour les utilisateur·trice·s qui signalent un bogue dans Mon parcours BBA%0D%0A%0D%0A
        1. Le bogue affecte-t-il votre profil ou plutôt celui de l’un·e de vos employé·e·s? Dans ce dernier cas, veuillez fournir le nom des personnes touchées ainsi que leur numéro d’employé·e, si disponible.%0D%0A%0D%0A%0D%0A
        2. Veuillez indiquer la date et l’heure approximative où le bogue est survenu. Il sera alors plus facile de le retracer dans nos bases de données.%0D%0A%0D%0A%0D%0A
        3. Une fenêtre avec un message d’erreur est-elle apparue sur la plateforme? Si oui, veuillez en faire une capture d’écran en ajoutant l’URL, l’heure et la date.%0D%0A%0D%0A%0D%0A
        4. Décrivez les étapes ayant menées au bogue afin que nous puissions le reproduire de notre côté.%0D%0A%0D%0A%0D%0A`,
    },
    relatedProject: {
        project: 'Projet',
        package: 'Lot',
        mFilesProjectRequired: 'Un projet M-Files valide est requis pour pouvoir soumettre ce formulaire.',
        projectNotInMFiles:
            "Ce projet n'est pas dans M-Files. Vous pouvez toujours soumettre le formulaire, mais il ne sera pas automatiquement archivé. Veuillez vérifier vos courriels pour archiver manuellement les fichiers après la soumission.",
        willBeArchived: 'Ce formulaire sera automatiquement archivé dans M-Files.',
        noPackage: 'Ce projet ne contient pas de lot. Veuillez en choisir un autre.',
        willBeArchivedFeedback: `Vous avez choisi un projet valide, merci!`,
        mFilesProjectRequiredFeedback: `Un projet M-Files valide est requis ou simplement ne rien écrire dans cette section pour pouvoir soumettre la rétroaction.`,
    },
    searchEmployee: {
        employee: 'Employé·e',
    },
    addFiles: {
        fileName: 'Nom',
        size: 'Taille',
        empty: 'Aucun fichier',
        addFiles: 'Ajouter des fichiers',
        fileCountLimit: 'Vous importez plus de fichiers que le maximum autorisé de {0}.',
        fileSizeLimit: 'Vos fichiers sont plus volumineux que la taille maximale autorisée de {0}.',
        reminder: `Ajouter des fichiers au besoin seulement.`,
    },
    goldenRules: {
        confirmGoldenRules: "Je confirme le respect des règles d'or de BBA.",
    },
    hrpSlider: {
        skipExplanation: "Vous avez spécifié comme quoi cette question n'est pas applicable.",
    },
    career: {
        identificationSectionName: 'Identification',
        pdfCreation: `Sauvegarder & clôturer la rencontre carrière`,
        whySendToManager: `À quoi sert notifier votre gestionnaire?`,
        becauseSendToManager: `Ce bouton sert à faire savoir à votre gestionnaire que vous avez terminé de documenter vos réflexions de carrière et que vous êtes fin prêt pour la rencontre.`,
        showManagerResult: `Montrer mes sélections à l'employé`,
        noCareer: `Il n'y a aucune rencontre de carrière pour l'instant!`,
        submitSuccessBody: `Votre rencontre carrière a été envoyée avec succès à votre chef d'équipe et a été sauvegardée`,
        freezeSuccesBody: `En cliquant sur OK, la rencontre Carrière sera placée à un statu commentaire post-rencontre et un PDF sera généré automatiquement. Toutefois, vous pourrez ajouter du contenu ou commenter tout au long de l'année et générer un nouveau PDF en fin d'année.`,
        closureSuccesBody: `En cliquant sur OK, la rencontre Carrière sera placée à un statut complété et un PDF sera généré automatiquement. Toutefois, vous NE pourrez PLUS ajouter du contenu ou commenter!`,
        closureTooltip: `À partir du 1er décembre de cette année je deviendrais actif. L'action de me cliquer aura pour effet que la rencontre Carrière sera placé à un statu complété et un PDF sera généré automatiquement. Toutefois, vous NE pourrez PLUS ajouter du contenu ou commenter!`,
        description: `Le niveau RH est celui pour l'année en cours.`,
        description2: `Il s'agit de celui qui vous a été communiqué lors de la remise de votre dernier relevé de rémunération ou, s'il y a lieu, lors de votre plus récent changement de poste. `,
        jobLevel: 'Niveau RH',
        specify: 'Spécifiez',
        nameActivities: 'Nommez les activités',
        plannedDate: 'Date de la rencontre',
        attentionOutlook: `Veuillez cocher l'option ci-haut pour générer une invitation d'une rencontre Outlook à l'instant (vous pourrez le faire ultérieurement également).`,
        attentionOutlook2: `Notez que si la date sur la rencontre Outlook est modifiée, celle-ci ne sera pas mise à jour dans Mon Parcours BBA.`,
        managerLabel: 'Gestionnaire réalisant la rencontre',
        manager: 'Gestionnaire',
        important: 'Important',
        newCareer: 'Créer une rencontre carrière',
        iUnderstand: "J'ai compris",
        importantNewText: `<p>Afin de vous soutenir dans votre développement de carrière, nous avons révisé et simplifié le formulaire de discussion de carrière.</p><p>Celui-ci se compose de cinq sections, conçues pour faciliter un échange structuré et enrichissant avec votre gestionnaire.</p><p>Un guide d'accompagnement est également disponible sur l'intranet; les liens sont accessibles directement dans le formulaire.</p>`,
        importantDialogText: `Les questions se trouvant dans le formulaire sont des pistes de réflexion et sont `,
        importantDialogText2: `facultatives`,
        importantDialogText3: `. Nous invitons les employés à répondre aux questions qui leur parlent et pour lesquelles ils souhaitent partager de l’information à leur gestionnaire. `,
        importantDialogText4:
            "L'évaluation pour l'employé concerné doit se faire en fonction de ses responsabilités actuelles (poste, rôle(s), niveau RH).",
        submitToMyManager: 'Envoyer à mon gestionnaire',
        scheduleMeeting: 'Planifier une réunion',
        career: 'Carrière',
        employee: 'Employé',
        legend: 'Légende',
        teamLeader: "Chef d'équipe",
        both: 'Les deux',
        submitConfirmTitle: 'Envoyer les information de carrière',
        submitConfirmBody: 'Les réponses ne pourront plus être modifié',
        addToOutlook: 'Planifier à Outlook',
        downloadPDF: 'Télécharger PDF',
        freezeDateNotice: 'Votre introspection de carrière a été figée le {0}.',
        meetingTitle: 'Invitation à Rencontre Carrière ([CurrentYear]) - [EmployeeName]',
        meetingDescription: `<p>Bonjour,</p>
        <p>Chez BBA, nous avons à cœur le développement de nos employés. Nous reconnaissons l'importance qu'ils se sentent encadrés et orientés dans leurs perspectives de carrière. Voici donc une invitation à une rencontre Carrière afin de discuter de l'évolution de [EmployeeName]. </p>
        <p><strong>Informations importantes en lien avec cette rencontre :</strong></p>
        <ul>
        <li>L'<u><strong>objectif</strong></u> de la rencontre Carrière, dans le cadre de Mon Parcours BBA, est de générer des <u>discussions riches et qualitatives</u>.</li>
        <li>Les questions proposées ont pour <strong><u>but</u></strong> d'amener l'employé à réfléchir à ses perspectives de carrière, son développement ainsi que de réaliser une <u>introspection professionnelle</u>.</li>
        <li><strong><u>Comment</u></strong> :<ul>
        <li>L'<u>employé</u> peut documenter ses réflexions d'introspection professionnelle en tout temps, de façon transparente et honnête.</li>
        <li>Le <u>gestionnaire</u> a pour rôle d'accompagner son employé au travers de ses réflexions et de le guider dans son cheminement professionnel.</li></ul></li>
        <li><u><strong>Quoi : Pistes de réflexions</strong></u><ul>
        <li>Intérêts (projets, postes, tâches, responsabilités, rôles)</li>
        <li>Axes BBA</li><li>Appréciation du poste, des rôles actuels</li>
        <li>Projection futur BBA (court, moyen et long terme)</li>
        <li>Intérêt pour affectations, mobilité, relocalisation</li>
        <li>Identification des forces et opportunités d'amélioration</li>
        <li>Soutien requis / Développement</li></ul>
        </li></ul>
        <ul><li><strong>Durée</strong> : Environ 60 minutes, selon les discussions. Nous vous invitons à vous référer au code de temps applicable 
        <a href="https://intranet.bba.ca/sites/practical-information/faq-portal/faq/3520/faq_which-time-code-do-i-need-to-use-for-my-bba-journey-meetings-and-engagement-activities">ici</a>.</li>
        <li><strong>Quand</strong> :
        <ul><li>Au moment où c'est opportun de le faire tant pour le gestionnaire que pour l'employé.</li>
        <li>Il n'y a pas de date fixe.</li><li>Ceci doit simplement être réalisé entre le 1er janvier et le 31 décembre de l'année courante.</li>
        <li>Il est possible de combiner cette rencontre avec un autre type de rencontre dans le cadre de Mon Parcours</li></ul>
        </li></ul>
        <p>Pour toute question au sujet de Mon Parcours BBA, nous vous invitons à consulter la section spécifique de l'Intranet à ce sujet en 
        <a href="https://intranet.bba.ca/sites/talent-development/SitePageModern/2172/my-bba-journey">cliquant ici</a>
         ou encore en questionnant votre gestionnaire et/ou votre PARH attitrée.</p>
        <p>Bonne journée!</p>
        <p>Service des Ressources humaines</p>`,
        outlookFileName: `Invitation à Rencontre Carrière ([CurrentYear]) - [EmployeeName]`,
        selectCareerReturnOnDevelopmentActivity: 'sélectionnez un rôle / une responsabilité',
        produceCar: 'Produire un document CAR',
        careerStatusLegendExplanation: [
            `Il est possible d’entrer des informations relatives à la Carrière de  l'employé·e. `,
            `L'employé·e à avisé son gestionnaire qu’il·elle est prêt·e pour la rencontre Carrière.`,
            `La rencontre est fermée; Il n'est donc plus possible d'ajouter du contenu.`,
            `La rencontre a eue lieu. Toutefois, vous pouvez continuer d’ajouter vos commentaires jusqu’à la fin de l’année de référence.`,
            `La rencontre et le processus d’approbation n’ont pas été complété dans les délais requis.`,
        ],
    },
    documentsRebranding: {
        documentType: 'Type de document',
        documentLanguage: 'Langue du document',
        uploadDocuments: 'Import des fichiers',
        importAll: 'Importer tout',
        restartImport: "Recommencer l'import",
        convertDocument: 'Convertir le(s) document(s)',
        previousStyle: 'Style précédent',
        replacementStyle: 'Style de remplacement',
        zipName: 'documents.zip',
    },
    documentsMFiles: {
        specify: 'Préciser si applicable',
        preview: 'Aperçu (MFile illustre où seront les champs)',
        header: 'Entête',
        body: 'Contenu',
        footer: 'Pied de page',
        documentLocation: 'Emplacement document',
        uploadDocuments: 'Import des fichiers',
        importAll: 'Importer tout',
        restartImport: "Recommencer l'import",
        modifyDocument: 'Modifier le(s) document(s)',
        mFilesFieldMapping: 'Ajuster le mappage des champs MFiles',
        addField: 'Ajouter un champ MFiles',
        addNewFieldTooltip: 'Cliquer pour ajouter un nouveau champ MFiles',
        previousMFilesField: 'Champ MFiles précédent',
        replacementMFilesField: 'Champ MFiles de remplacement',
        zipName: 'documents.zip',
        legends: 'Légendes des couleurs',
        fromDb: 'Champ configuré',
        unSet: 'Champ non défini',
        modified: 'Champ modifié',
        confirmIgnoreConfiguration: 'Confirmer la configuration a ignorée',
        confirmConfigurationDeleteBody: 'Êtes-vous sûr de vouloir supprimer cette configuration?',
        confirmConfigurationResetBody: 'Êtes-vous sûr de vouloir annuler la modification?',
        confirmConfigurationIgnoreBody: 'Êtes-vous sûr de vouloir ignorer cette configuration?',
        ignoreConfigurationToolTip: 'Ignore cette configuration pour le traitement des fichiers',
        restoreConfigurationToolTip: 'Rétablir cette configuration pour le traitement des fichiers',
        ignoreConfiguration: 'Ignorer',
        removeConfiguration: 'Supprimer cette configuration pour le champs MFiles',
        editConfiguration: 'Modifier cette configuration pour le champs MFiles',
        addConfiguration: 'Ajouter cette configuration pour le champs MFiles',
    },
    myTeam: {
        consultant: `Liste des employé·e·s qui sont consultant·e·s au sein de BBA`,
        notFound: `Pour la recherche que vous effectuez, nous n'obtenons aucun résultat! Veuillez essayer avec d'autres critères de recherche.`,
        yearReferenceSubtitle: `           
        <p>
        Veuillez choisir une année dans le menu déroulant ci-bas pour afficher les résultats de votre équipe actuelle en lien avec cette année de
        référence! Par défaut c'est l'année en cours qui est choisie!
        </p>
        <h4 style="color:#002952">Important</h4>
        <p>
            <u>S'il y a eu des changements organisationnels durant l'année!</u> Il est donc possible que vous n'ayez plus accès aux dossiers des
            employé·e·s dont vous étiez responsable. Mon parcours se base sur le lien  hiérachique (section 'Report-to' de la fiche employé·e dans MFiles), pour vous
            afficher la liste des employé·e·s.
        </p>
        <p>
            Si vous êtes en charge de finir l'année d'évaluation d'un employé·e·s qui a changé de gestionnaire. Veuillez svp
            communiquer avec ce dit gestionnaire.
        </p>`,
        warningsDashbord: `Seulement les employé·e·s de type régulier sont affichés dans le tableau de bord!`,
        legendExplenation: `L'étoile est pour identifier les employé·e·s qui sont de type `,
        legendExplenation2: `régulier`,
        legendExplenation3: `. Donc ils·elles ne sont ni stagiaire, ni temporaire, ni étudiant.`,
        consultantExplenation: `Seul·e·s les consultant·e·s qui ont accès à Mon parcours sont affiché·e·s. C’est-à-dire, ceux et celles qui ont un adresse courriel BBA.`,
        noEmployee: 'Vous ne supervisez pas aucun employé·e',
        noNotes: `Vous n'avez pas de note à propos de cette employé·e`,
        lastUpdate: 'Dernière mise à jour',
        nextUpdate: 'Prochaine mise à jour',
        left: 'À faire',
        completed: 'Complété',
        myTeam: 'Mon équipe',
        objective: 'Objectif',
        objectives: 'Objectifs',
        annualObjectives: 'Objectifs annuels',
        feedback: 'Rétroaction',
        feedbacks: `Pour la colonne de rétroaction le chiffre de gauche est la quantité de rétroactions reçues par l'employé·e et le chiffre de droite la quantité envoyées.`,
        sentFeedbacks: 'Rétroactions reçues | envoyées',
        targetPercentage: '% Cible',
        jobLevel: 'Niveau RH',
        followUp: 'Suivi',
        firstFollowUp: 'Premier suivi',
        secondFollowUp: 'Deuxième suivi',
        career: 'Carrière',
        overallAssessment: 'Appréciation Globale',
        target: 'Objectif',
        hrLevel: 'HR Level',
        viewOverall: `Voir l'appréciation globale`,
        profileOf: 'Profil de {0}',
        exitProfile: 'Sortir du profil',
        viewFollowUps: 'Voir les suivis',
        viewObjectives: 'Voir les objectifs',
        viewFeedbacks: 'Voir les rétroactions',
        employeeNotes: "Notes sur l'employée (confidentiel pour gestionnaires + PARH)",
        careers: 'Carrière',
        viewPersonalNotes: 'Voir les notes personnelles',
        viewCareer: 'Voir Carrière',
        addNote: 'Ajouter une note',
        noNote: 'Aucune note personnelle existante',
        performanceCriteria: 'Critère de performance',
        author: 'Auteur(e)',
        newPersonalNote: 'Nouvelle note personnelle',
        editPersonalNote: 'Modifier la note personnelle',
        deleteNoteTitle: 'Supprimer la note?',
        deleteNoteBody: 'Vous êtes sur le point de supprimer la note personnelle de façon permanente.',
        disabledPersonalNote: 'Cette note personnelle est en cours de synchronisation, elle ne peut donc pas être modifiée pour le moment',
    },
    covid: {
        isEmployee: 'Je suis un employée de BBA',
        officeVisited: 'Bureau visité',
        visitDated: 'Visite en date du',
        last30Days: '30 derniers jours',
        generalSummary:
            "Si vous avez répondu OUI à l'une ou l'autre des questions ci-dessous, vous n'êtes pas autorisé à entrer dans nos installations et celles de nos clients. Si vous présentez des symptômes associés à la COVID-19 pendant que vous êtes au bureau, vous devez renter chez vous et contacter la santé publique de votre province pour obtenir les directives. Pour les employés de BBA contacter votre chef de service ou le département SSE. Pour les employés de BBA veuillez contacter votre chef de service ou le département SSE.",
        labradorSummary:
            "Advenant un NON à la dernière question ou un OUI à tout autre question, vous n'êtes pas autorisé à entrer dans nos installations et celles de nos clients. Si vous présentez des symptômes associés à la COVID-19 pendant que vous êtes au bureau, vous devez rentrer chez vous et contacter la santé publique de votre province pour obtenir les directives. Pour les employés de BBA veuillez contacter votre chef de service ou le département SSE.",
        validInformation: 'Je confirme que toutes les informations saisies sont véridiques.',
        bbaKeepInformation: "J'autorise également BBA à conserver cette déclaration pour une durée de 30 jours.",
        goToGuestForm: 'Formulaire visiteur',
        goToEmployeeForm: 'Formulaire employé',
        goToFormList: 'Liste formulaires',
        consultSymptoms: 'Consulter les symptômes',
        company: 'Entreprise',
        authorized: 'Authorisé',
        presences: 'Présences total',
    },
    preferences: {
        feedbackNotifSettingTitle: "Pourquoi avons-nous désactivé l'option?",
        feedbackNotifSettingText:
            "Chez BBA, la rétroaction est considérée urgente et importante. Dans le but de renforcer ce type d'interaction entre les employés et la gestion, nous désirons garder les notifications actives. Merci de votre compréhension!",
        emailNotification: "M'informer des nouvelles notifications par courriel pour les sections suivantes :",
        recordPreferences: 'Enregistrer vos préférences',
    },
    notifications: {
        notification: 'Notifications',
        deleteWarning: `Vous n'avez pas réussi à effacer la notification. Veuillez recommencer.`,
        markAsSeenWarning: `Vous n'avez pas réussi à marque comme vu la notification. Veuillez recommencer.`,
        loadingError: `Nous n'avons pas pu retrouver les notifications liées a votre compte. Veuillez actualiser la page ou appuyer sur F5`,
    },
    overallAssessment: {
        produceAga: `Produire un document AGA`,
        weightSumWarningTitle: `***Attention, le calcule de la performance a ce temps ci de l'année calcul aussi avec la complétion de l'objectif opérationnel si vous y êtes admissible.`,
        performance: `Performance`,
        targetInfo: `Si jamais le pourcentage(%) cible ne correspond pas à ce que l'employé doit avoir, svp, communiquer avec Caroline Ménard des RH.`,
        revisionTitle: `Demande de révision acheminée`,
        revisionContent: `Une notification a bien été envoyée à votre gestionnaire. Vous serez maintenant redirigé vers la page d'acceuil de cette section.`,
        freezeTitle: `Appréciation globale terminée`,
        freezeMeeting: `Vous avez bien clôturé la rencontre d'appréciation globale de votre employé·e. Maintenant assurez-vous que votre employé·e approuve plus bas de la dite rencontre.`,
        chooseYour: `Veuillez choisir`,
        chooseExplaination: `Faite votre sélection pour afficher votre choix`,
        whyReview: `Pourquoi une demande de révision?`,
        becauseReview: `La demande de révision est pour permettre d'ajouter des commentaires ou des fichiers attachés à une rencontre d'appréciation globale. En appuyant sur le bouton une notification 
        sera envoyé à votre gestionnaire pour qu'il·elle réouvre la rencontre.`,
        revision: `Demande de révision à votre gestionnaire`,
        revisionManager: `Réactiver la rencontre`,
        whyReviewManager: `Pourquoi réouvrir la rencontre?`,
        becauseReviewManager: `Parce que votre employé·e vous demande de réouvrir la rencontre d'appréciation globale dans le but d'y ajouter / modifier
         du contenu. Ou encore, vous désirez changer le contenu avant que les (2) deux parties aient approuvé.`,
        approbationButtonTosign: `J'approuve`,
        approbationButtonSigned: `Approuvé`,
        approbationEmployee: `Approuver votre rencontre d'appréciation globale`,
        approbationManager: `Approuver la rencontre de votre employé·e`,
        objectiveType: ['Nouvel objectif stratégique', 'Nouvel objectif de rôle', 'Nouvel objectif de poste'],
        objectifFreezed: 'Voici les objectifs que vous avez figé avec votre gestionnaire',
        objectiveNotFreezed: "Voici les objectifs que vous avez ajouté en cours d'année",
        noOverall: `Il n'y a aucune rencontre d'appréciation globale pour l'instant!`,
        submitSuccessBody: `Votre rencontre d'appréciation globale a été envoyée avec succès à votre gestionnaire et a été sauvegardée.`,
        submitSuccessBodySave: `Votre rencontre d'appréciation globale a été sauvegardée. Vous allez être redirigé·e vers la page d'accueil d'appréciation globale!`,
        submitSuccessBodySaveManager: `La rencontre d'appréciation globale de votre employé·e a été sauvegardée. Vous allez être redirigé·e vers la page d'accueil d'appréciation globale de votre employé·e!`,
        year: `Année d'évalution`,
        newOverall: `Nouvelle rencontre d'appréciation globale`,
        noOverallAssessment: `Vous n'avez pas de rencontre d'appréciation global pour l'instant`,
        sectionEmployee: "Section de l'employé·e",
        sectionManager: 'Section du gestionnaire',
        rapidAcces:
            'Vous pouvez accédez rapidement à vos rétroactions, vos rencontres de suivi, et votre rencontre carrière avec les menus déroulants ci-bas',
        comment: 'Commentaire·s précédent·s',
        commentFinal: "Commentaire·s de fin d'année",
        overallAssessment: 'Appréciation globale',
        employeeParts: 'Décrivez votre année chez BBA',
        managerParts: "Décrivez l'année de votre employé­­·e",
        feedbacks: 'Vos rétroactions',
        followUps: 'Rencontres de suivi',
        career: 'Rencontre Carrière',
        appreciation: "L'APPRÉCIATION GLOBALE de fin d'année est l'étape de clôture de l'année en matière de gestion de performance.",
        firstBullet:
            'Pour tous·tes les employé·e·s, il s’agit de faire une revue de l’année terminée, des réalisations, de l’atteinte des objectifs annuels et de la performance globale (état des objectifs, pourcentage de réalisation et commentaires pertinents).',
        secondBullet:
            "IMPORTANT: dans la section des objectifs lors de l'appréciation globale, Seulement les gestionnaires peuvent modifier les objectifs (description & poids). TOUS (employé·e·s comme gestionnaires) peuvent mettre des commentaires de fin d'année.",
        careerImportant: 'RENCONTRE CARRIÈRE:',
        fourthBullet:
            "Veuillez-vous assurer que la rencontre Carrière est adéquatement documentée tant par l'employé·e que le gestionnaire et que tout commentaire pertinent à propos de l'année en cours s'y trouve.",
        fifthBullet: "Le gestionnaire est responsable de figer la rencontre Carrière pour l'année en cours.",
        titleIsEmptyFeedback: `Vous n'avez pas de rétroactions`,
        titleIsEmptyFollowUp: `Vous n'avez pas de rencontres suivi`,
        titleIsEmptyCareer: `Vous n'avez pas de rencontres carrière`,
        textIsEmptyFeedback: `N'oublier pas que BBA encourage la rétroaction! N'hésiter pas faire de la rétroaction positive ou constructive à vos collègues.`,
        textIsEmptyFollowUp: `Vos rencontres n'ont pas été fermé. Veuillez demander à votre gestionnaire de fermer vos suivis en appuyant sur le bouton fin de rencontre. Ou sinon vous n'avez pas fait de rencontre de suivie durant l'année.`,
        textIsEmptyCareer: `Votre rencontre n'a pas été fermé. Veuillez demander à votre gestionnaire de fermer votre carrière en appuyant sur le bouton fin de rencontre. Ou sinon vous n'avez pas fait de rencontre carrière durant l'année.`,
        outlookFileName: `Invitation - Mon parcours rencontre d’Appréciation globale - ([EmployeeName])`,
        overallAssessmentTitle: 'Invitation - Mon parcours rencontre d’Appréciation globale - ([EmployeeName])',
        overallAssessmentDescription: `<p><span style='font-family:"Century Gothic",sans-serif'>Bonjour,</span></p>        
        <p><span style='font-family:"Century Gothic",sans-serif'>Voici venu le moment de faire une revue de l’année en regard de la contribution individuelle et de réaliser la rencontre <b>d’Appréciation globale</b>.</span></p>        
        <p><span style='font-family:"Century Gothic",sans-serif'>Informations importantes en lien avec cette rencontre :</span></p>
        <ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>L’objectif de la rencontre <b>d’Appréciation globale</b> dans le cadre de Mon Parcours BBA, est de clôturer l’année.</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>Cette rencontre comporte deux (2) buts précis :</span></li>
                <ul>
                    <li><span style='font-family:"Century Gothic",sans-serif'>Discuter de l’évolution des <b>objectifs annuels</b> et <b>conclure au sujet de leur statut final</b></span></li>
                    <li><span style='font-family:"Century Gothic",sans-serif'>Effectuer une <b>rétrospective de l’année entière</b> et mettre en lumière les éléments marquants concernant l’employé·e</span></li>
                </ul>
        </ul>        
        <p><span style='font-family:"Century Gothic",sans-serif'>Comment :  </span></p>
        <ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>L’employé·e et son gestionnaire se préparent à la rencontre :</span></li>
                <ul>
                    <li><span style='font-family:"Century Gothic",sans-serif'>En documentant et commentant l’évolution des objectifs (Commentaires de fin d’année) </span></li> 
                    <li><span style='font-family:"Century Gothic",sans-serif'>En statuant sur les objectifs, leur pourcentage de complétion et poids de ceux-ci (seulement le gestionnaire peut modifier)</span></li>                   
                    <li><span style='font-family:"Century Gothic",sans-serif'>En inscrivant, dans leur espace respectif, tout élément pertinent au sujet de la performance annuelle de l’employé·e</span></li>
                </ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>Ils planifient au calendrier une rencontre <b>d’Appréciation globale</b> et tiennent cette rencontre</span></li>
            <li><span style='font-family:"Century Gothic",sans-serif'>Lors de la rencontre, ils discutent de leurs constats respectifs</span></li>                  
            <li><span style='font-family:"Century Gothic",sans-serif'>Une fois la rencontre tenue et adéquatement documentée, l’employé·e et son gestionnaire signent le formulaire <b>Appréciation globale directement dans Mon Parcours BBA</b></span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>Le gestionnaire approuve <b>l’Appréciation globale directement dans Mon Parcours BBA</b></span></li>
        </ul>        
        <p><span style='font-family:"Century Gothic",sans-serif'>Quoi : Outils complémentaires à prendre en considération pour le bilan annuel final</span></p>
        <ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>Objectifs annuels de l’employé·e</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>Rétroactions</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>Rencontres de suivi</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>Rencontre carrière</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>Tous les autres outils pertinents disponibles</span></li>
        </ul>        
        <p><span style='font-family:"Century Gothic",sans-serif'>Durée : Durée de la rencontre : Environ 30 minutes, selon les discussions. Nous vous invitons à vous référer au code de temps applicable  </span><span><a
        href="https://intranet.bba.ca/sites/practical-information/faq-portal/faq/3520/faq_which-time-code-do-i-need-to-use-for-my-bba-journey-meetings-and-engagement-activities"><b><span style='font-family:"Century Gothic",sans-serif'>ici</span></b></a></span><b><span style='font-family:"Century Gothic",sans-serif'>.</span></b></p>
        <p><span style='font-family:"Century Gothic",sans-serif'>Quand : </span></p>        
        <ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>À partir de décembre.</span></li>           
            <li><span style='font-family:"Century Gothic",sans-serif'>Se référer aux dates communiquées dans les communications sur l’Intranet et l’Intercom à cet effet.</span></li>
        </ul>        
        <p><span style='font-family:"Century Gothic",sans-serif'>Pour toute question au sujet de Mon Parcours BBA, nous vous invitons à consulter la section spécifique de l’intranet à ce sujet en </span><span>
        <a href="https://intranet.bba.ca/sites/talent-development/SitePageModern/2172/my-bba-journey"><b><span style='font-family:"Century Gothic",sans-serif'>cliquant ici</span></b></a></span>
        <span style='font-family:"Century Gothic",sans-serif'> ou encore en questionnant votre gestionnaire ou votre PARH attitrée.</span></p>
        <p><span style='font-family:"Century Gothic",sans-serif'>Bonne journée!</span></p>       
        <p><span style='font-family:"Century Gothic",sans-serif'>Service des Ressources humaines</span></p>`,
        warningCareerReviewTitle: `Voulez-vous revoir la rencontre Carrière de votre employé·e?`,
        warningCareerReviewBody: `Maintenant que l'Appréciation globale est clôturée, nous vous suggérons fortement d'aller
         visualiser la rencontre Carrière de votre employé·e, d'en réviser le contenu et de fermer celle-ci.`,
        warningCareerReviewButton: `Voir la rencontre Carrière.`,
        overallStatusLegendExplanation: [
            `Il est possible d’entrer des informations relatives à l’Appréciation globale de l'employé·e.`,
            `Les deux parties ont signés et la rencontre est fermée. Il n'est donc plus possible d'ajouter du contenu.`,
            ``,
            `Il manque l’une ou l’autre des signatures.`,
            `L'employé·e à avisé son gestionnaire qu’il·elle est prêt·e pour la rencontre d’Appréciation globale.`,
            `Le gestionnaire a procédé à la ré-ouverture de la rencontre.`,
            `Le moment n'est pas encore venu de compléter votre Appréciation globale.`,
            ``,
            `La rencontre est fermée automatiquement car le délai de fermeture est expiré. Veuillez remplir celui de l'année en cours.`,
        ],
    },
    synergy: {
        create: 'Créer',
        save: 'Sauvegarder',
        employee: 'Employé',
        nameFrench: 'Nom français',
        nameEnglish: 'Nom anglais',
        teamKey: 'Clé unique',
        referenceYearLabel: 'Année de référence',
        employeeException: {
            referenceYear: 'Année de référence',
            groupOriginal: 'Groupe original',
            groupManual: 'Groupe modifié',
            departmentOrginal: 'Départment original',
            departmentManual: 'Département modifé',
            businessCategoryOriginal: "Catégorie d'affaire original",
            businessCategoryManual: "Catégorie d'affaire modifé",
            originalEligibility: "Admissibilité d'origine",
            manualEligibility: 'Admissibilité manuelle',
            targetOriginal: '% Cible bonus original',
            targetManual: '% Cible bonus manuel',
            originalQtyMinObjective: "Nombre d'objectif minimal original",
            manualQtyMinObjective: "Nombre d'objectif minimal manuel",
            originalQtyMaxObjective: "Nombre d'objectif maximal original",
            manualQtyMaxObjective: "Nombre d'objectif maximal manuel",
            originalHrLevel: "Niveau RH d'origine",
            manualHrLevel: 'Niveau RH Manuel',
            isEligible: 'Est eligible',
            hasThatObjective: 'Est eligible à cette objectif',
            weightOriginal: "Poids original de l'objectif",
            weightManual: "Poids manuel de l'objectif",
            internalNote: 'Note interne',
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à cette exception employé !',
            createYear: `Dupliquer les données à partir de l'année précédante`,
            duplicate: `Dupliquer`,
        },
        referenceYear: {
            calendarYear: 'Année calendrier',
            calendarYearError: "L'année calendrier devrait être la même année que la date limite",
            startDate: 'Date de début',
            startDateError: 'La date de début doit être plus tôt que la date de fin',
            endDate: 'Date de fin',
            endDateError: 'La date de fin doit être plus tard que la date de début',
            deadline: 'Date butoir',
            cutOffDate: 'Date limite pour changement niveau RH',
            openingOfOverall: `Ouverture d'appréciation global`,
            closingOfOverall: `Fermeture d'appréciation global`,
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à cette année de référence !',
        },
        businessCategory: {
            deletePart2: "Cette action va également supprimer tout ce qui est lié à cette catégorie d'affaires !",
        },
        region: {
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à cette région !',
            businessCategorie: "Catégorie d'affaires",
        },
        office: {
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à ce bureau !',
            region: 'Région',
        },
        departement: {
            key: 'Clé',
            uniqueKey: 'Clé unique',
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à ce département !',
        },
        manager: {
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à ce gestionnaire !',
            originalManagerType: 'Type de gestionnaire original',
            manualManagerType: 'Type de gestionnaire manuel',
            originalGroupSize: 'Taille de groupe original',
            manualGroupSize: 'Taille de groupe manuelle',
            employee: 'Employé',
            synchronizeManagerWarning:
                "Attention! Cette action va mettre à jour tous les gestionnaires de la liste pour l'année sélectionnée!",
            actions: 'Actions',
            hrLevel: 'Niveau RH',
            cantSynchronize: "La date butoire étant dépassée, la syncronisation n'est plus permise",
            synchronizeAllManagers: 'Synchroniser tous les managers',
            isDeleted: 'Est effacé',
        },
        baseHrLevelFamily: {
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à cette famille !',
            uniqueKey: 'Clé unique',
            associatedHrLevels: 'Niveaux RH associés',
            bottomThreshold: 'Min. Nb. Objectifs',
            topThreshold: 'Max Nb. Objectifs',
        },
        group: {
            titleFr: 'Titre FR',
            titleEn: 'Titre EN',
            uniqueKey: 'Clé unique',
            groupType: 'Type de groupe',
            businessCategorie: "Catégorie d'affaires",
            departements: 'Départements',
            office: 'Bureau',
            region: 'Region',
            or: 'OU',
            noDepartement: 'Aucun département associé',
        },
        managerTypeGroupSize: {
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à cette configuration !',
            managerType: 'Type de gestionnaire',
            groupSize: 'Taille de groupe',
            bottomThreshold: 'Borne inférieure',
            topThreshold: 'Borne supérieure',
        },
        groupType: {
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à ce type de groupe !',
        },
        objective: {
            titleFr: 'Titre FR',
            titleEn: 'Titre EN',
            businessCategorie: "Catégorie d'affaires",
            hrLevel: 'Niveau RH',
            weight: 'Poids',
            uniqueIdentifier: 'Identifiant unique',
            noObjective: "Pas d'objectif",
            criteria: 'Critères',
            isTeamLeadConfig: 'Contient une configuration pour les Team lead',
            value: 'Valeur',
            completion: 'Complétion',
            teamLeadCriteria: 'Critères Team Lead',
            deletePart2: 'Cette action va également supprimer tout ce qui est lié à ce critères de niveau RH !',
            baseHrLevelFamilies: 'Famille de Niveau RH',
            managerType: 'Type de gestionnaire',
            groupSize: 'Taille de groupe',
        },
        report :{
            reportType: "Type de rapport",
            generateReport: "Générer"
        },
    },
    hierarchy: {
        manager: 'Gestionnaire',
        directReport: 'Subordonné direct',
        directReports: 'Subordonnés directs',
        startDate: `Début de l'affectation`,
        endDate: `Fin de l'affectation`,
        duration: `Durée de l'affectation (jours)`,
        reason: `Raison de l'affectation`,
        reasonError: `Ce champ est obligatoire. Vous devez fournir une explication pour cette opération.`,
        actions: 'Actions'
    },
};

export default fr;
